export default "__VITE_ASSET__BNlydLVx__"